import { useEffect, useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

interface NotificationTemplate {
  id: string;
  notification_type: string;
  channel: string;
  title: string | null;
  message: string;
  enabled: boolean;
}

export const useNotifications = () => {
  const [templates, setTemplates] = useState<NotificationTemplate[]>([]);

  useEffect(() => {
    loadTemplates();
  }, []);

  const loadTemplates = async () => {
    const { data } = await supabase
      .from("notification_templates")
      .select("*")
      .eq("channel", "toast")
      .eq("enabled", true);
    
    if (data) {
      setTemplates(data);
    }
  };

  const getRandomTemplate = (type: string): NotificationTemplate | null => {
    const matching = templates.filter(t => t.notification_type === type);
    if (matching.length === 0) return null;
    return matching[Math.floor(Math.random() * matching.length)];
  };

  const notify = async (type: string, fallbackTitle?: string, fallbackMessage?: string) => {
    const template = getRandomTemplate(type);
    
    if (template) {
      toast(template.title || fallbackTitle || "Notification", {
        description: template.message,
      });
    } else if (fallbackMessage) {
      toast(fallbackTitle || "Notification", {
        description: fallbackMessage,
      });
    }

    // Trigger email notification via edge function
    try {
      await supabase.functions.invoke("send-notification", {
        body: { type, channel: "email" }
      });
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.error("Failed to send email notification:", error);
      }
    }
  };

  return {
    notify,
    templates,
    loadTemplates,
  };
};
